import { render, staticRenderFns } from "./JRG.vue?vue&type=template&id=b7e2a07e"
import script from "./JRG.vue?vue&type=script&lang=js"
export * from "./JRG.vue?vue&type=script&lang=js"
import style0 from "./JRG.vue?vue&type=style&index=0&id=b7e2a07e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports